import { privateRequest } from "../axios";
import type { Vendor, VendorsResponse } from "@/types/vendortypes";

const ENDPOINTS = {
  VENDOR: "/vendor",
  VENDOR_ID: (id: string | number) => `/vendor/${id}`,
  UPDATE_STATUS: (id: string | number) => `/vendor/status/${id}`,
};

const getVendors = async (
  params?: Record<string, any>
): Promise<VendorsResponse> => {
  const response = await privateRequest.get<VendorsResponse>(ENDPOINTS.VENDOR, {
    params,
  });
  return response.data;
};

const getVendorById = async (id: string | number): Promise<Vendor> => {
  const response = await privateRequest.get<Vendor>(ENDPOINTS.VENDOR_ID(id));
  return response.data;
};

const addVendor = async (data: Partial<Vendor>): Promise<Vendor> => {
  const response = await privateRequest.post<Vendor>(ENDPOINTS.VENDOR, data);
  return response.data;
};

const updateVendor = async (
  id: string | number,
  data: Partial<Vendor>
): Promise<Vendor> => {
  const response = await privateRequest.put<Vendor>(
    ENDPOINTS.VENDOR_ID(id),
    data
  );
  return response.data;
};

const updateVendorStatus = async (
  id: string | number,
  data: Partial<Vendor>
): Promise<Vendor> => {
  const response = await privateRequest.put<Vendor>(
    ENDPOINTS.UPDATE_STATUS(id),
    data
  );
  return response.data;
};

const deleteVendor = async (
  id: string | number
): Promise<{ success: boolean; message: string }> => {
  const response = await privateRequest.delete<{
    success: boolean;
    message: string;
  }>(ENDPOINTS.VENDOR_ID(id));
  return response.data;
};

const VendorService = {
  getVendors,
  getVendorById,
  addVendor,
  updateVendor,
  updateVendorStatus,
  deleteVendor,
};

export default VendorService;
